/**
 * @generated SignedSource<<68fb0ebcca96b49fccbe043dc4397033>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AuthContextLogoutMutation$variables = {};
export type AuthContextLogoutMutation$data = {
  readonly logout: {
    readonly viewer: {
      readonly __typename: "Viewer";
      readonly user: {
        readonly username: string | null;
      } | null;
    } | null;
  } | null;
};
export type AuthContextLogoutMutation = {
  response: AuthContextLogoutMutation$data;
  variables: AuthContextLogoutMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AuthContextLogoutMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "LogoutPayload",
        "kind": "LinkedField",
        "name": "logout",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "GalleryUser",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AuthContextLogoutMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "LogoutPayload",
        "kind": "LinkedField",
        "name": "logout",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "GalleryUser",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "19c58c82a9a4f906dc8f8e4e23d84bb4",
    "id": null,
    "metadata": {},
    "name": "AuthContextLogoutMutation",
    "operationKind": "mutation",
    "text": "mutation AuthContextLogoutMutation {\n  logout {\n    viewer {\n      __typename\n      user {\n        username\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f32abf1620dec3adb9dc36c03ab2b541";

export default node;
